// /settings/profile (PRD §9.9, B6 PR1 / B6a).
//
// Thin shell that mounts <ProfilePage>. Auth is enforced by
// __root.tsx's beforeLoad guard, so by the time this renders we have
// a session — and <ProfilePage> handles its own pending / error state
// off the useMe query.

import { createFileRoute, Link } from '@tanstack/react-router';

import { ApiError, apiErrorMessage } from '../api/client';
import { ProfilePage } from '../components/ProfilePage';

export const Route = createFileRoute('/settings/profile')({
  component: ProfileRoute,
  errorComponent: SettingsRouteError,
});

function ProfileRoute(): React.JSX.Element {
  return <ProfilePage />;
}

function SettingsRouteError({ error }: { error: unknown }): React.JSX.Element {
  const isApi = error instanceof ApiError;
  const status = isApi ? error.status : null;
  const heading =
    status === 401
      ? 'Your session has expired'
      : 'Something went wrong loading your settings';
  const body = apiErrorMessage(error, 'Try again, or return to the home page.');

  return (
    <div className="mx-auto max-w-2xl py-7">
      <p className="text-text-faint text-11 mb-2 uppercase tracking-wider">
        Error
      </p>
      <h1 className="text-text text-28 mb-3 font-semibold">{heading}</h1>
      <p className="text-text-muted mb-5 text-13">{body}</p>
      <Link
        to="/"
        className="bg-accent text-accent-fg border-border-strong rounded-2 hover:bg-accent-hi inline-block border px-3 py-2 text-13 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
